import React, { Component } from 'react';
import Typewriter from 'typewriter-effect';


class Header extends Component {
  render() {

    if(this.props.data){
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }
    return (
      <header id="home">
      <nav id="nav-wrap">
         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">About</a></li>
	         <li><a className="smoothscroll" href="#me">Me</a></li>
            <li><a className="smoothscroll" href="#portfolio">Portfolio</a></li>
         </ul>
      </nav>

      <div className="row banner">
         <div className="banner-text">
            <Typewriter options={{strings: ['Alice Gao'], autoStart: true,loop: true,}}/>
            <h3>Software Eng @ University of Waterloo</h3>
            <ul className="social">
               {networks}
            </ul>
         </div>
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;
